export const allotmentSummaryConstants = {

    // REQUEST_ALLOTMENT_SUMMARY 
    REQUEST_ALLOTMENT_SUMMARY: 'REQUEST_ALLOTMENT_SUMMARY',
    RECEIVE_ALLOTMENT_SUMMARY: 'RECEIVE_ALLOTMENT_SUMMARY',
    ALLOTMENT_SUMMARY_ERROR: 'ALLOTMENT_SUMMARY_ERROR',

};


// WEBPACK FOOTER //
// ./src/_constants/allotmentSummary.constants.js